import React, {createContext, useContext, useEffect, useState} from 'react';
import {getUserProfileRequest, logoutRequest} from 'util/api';
import {WebSocketContext} from 'wss/WebSocketService';
import {CustomError} from 'util/apiHelper';
import {isMoneyHostname} from 'util/configuration';

export const UserContext = createContext();

export const UserProvider = ({children}) => {
    const wsService = useContext(WebSocketContext);
    const [user, setUser] = useState({
        isLoggedIn: localStorage.getItem('isLoggedIn'),
        balance: null,
        profileImage: '',
        username: null,
        userId: null,
        keyCount: 0,
        lootBoxCount: 0,
        badge: 'loading',
        badgeIndex: 0,
        setProfileImage: (profileImageUrl) => setUser((prevState) => ({...prevState, profileImage: profileImageUrl})),
    });

    // Fetch user data on mount
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const profileData = await getUserProfileRequest();
                setUser((prevState) => ({
                    ...prevState,
                    balance: profileData.balance,
                    username: profileData.username,
                    userId: profileData.id,
                    keyCount: profileData.keyCount,
                    lootBoxCount: profileData.lootBoxCount,
                    profileImage: profileData.profilePictureId,
                    badge: profileData.badge,
                    badgeIndex: profileData.badgeIndex,
                    // Fetch and set other user-related data here
                }));
                console.log('User data fetched:', profileData);
            } catch (error) {
                if (!(error instanceof CustomError) || window.location.pathname === '/page-rules') {
                    return;
                }
                await logoutRequest();
                localStorage.removeItem('isLoggedIn');
                window.location.reload();
            }
        };

        if (user.isLoggedIn) {
            fetchUserData();
        }
    }, [user.isLoggedIn]);

    // Handle WebSocket messages
    useEffect(() => {
        const handleMessage = (content, topic) => {
            switch (topic) {
                case 'balance':
                    setUser((prevState) => ({...prevState, balance: content.value}));
                    break;
                case 'keyCount':
                    setUser((prevState) => ({...prevState, keyCount: content.value}));
                    break;
                case 'lootBoxCount':
                    setUser((prevState) => ({...prevState, lootBoxCount: content.value}));
                    break;
                case 'badgeIndex':
                    setUser((prevState) => ({...prevState, badgeIndex: content.value}));
                    break;
                default:
                    console.warn(`Unhandled topic: ${topic}`);
            }
        };

        if (user.isLoggedIn) {
            wsService.connect();
            // Subscribe to topics
            const topics = ['balance', 'keyCount', 'lootBoxCount', 'badge'];
            topics.forEach((topic) => {
                wsService.bindChannel(topic);
                wsService.onMessage(topic, handleMessage);
            });
        }

        // Cleanup on unmount
        return () => {
            const topics = ['balance', 'keyCount', 'lootBoxCount', 'badge'];
            topics.forEach((topic) => {
                wsService.offMessage(topic, handleMessage);
                wsService.unbindChannel(topic);
            });
        };
    }, [user.isLoggedIn, wsService]);

    return (
        <UserContext.Provider value={{user, setUser, isCashTenant: isMoneyHostname()}}>
            {children}
        </UserContext.Provider>
    );
};